export default __webpack_public_path__ + "static/wetSignPicture-7c4aec2723ca69081da92d19d4b13d8c.svg";